module.exports = __webpack_public_path__ + "img/15.ad983538.jpg";